var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-doctor-manage',{ref:"table",staticClass:"pt-doctor-manage__withData",attrs:{"exportLoading":_vm.exportLoading},on:{"deleteDoctor":_vm.deleteDoctor,"exportDoctorQrcode":_vm.exportDoctorQrcode}})}
var staticRenderFns = []

export { render, staticRenderFns }